import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { TimelineMax, TweenMax } from 'gsap';
import styles from './index.module.scss';
import { createEFPic } from '@/utils/useEFPic';
import { useLang } from '@/i18n';

const { EFPic } = createEFPic('/media/ecocredits-day/pc/');

export default function FirstKv() {
    const { t } = useLang('ecocreditsday');
    const { locale } = useRouter();
    const [showAni, setShowAni] = useState(false);
    const kvMap = { jp: 'kv' };
    const kvName = kvMap[locale as keyof typeof kvMap] || kvMap.jp;

    useEffect(() => {
        setShowAni(true);
        const scene = new ScrollMagic.Scene({
            triggerElement: '.firstKv',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 400,
        });
        const timeline = new TimelineMax();
        const tweenA1 = TweenMax.to('.kv-text__box', 0.25, { y: -80 });
        const tweenA2 = TweenMax.to('.opacity-box', 0.25, { opacity: 0 });
        timeline.add(tweenA1).add(tweenA2, 0.4);
        scene.setTween(timeline);
        controllerDay.addScene(scene);

        // 第一屏视差效果
        const sceneHideModal = new ScrollMagic.Scene({
            triggerElement: '.ecoflow-frame-header',
            offset: 0, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: 460,
        });

        const tweenHide = TweenMax.to('.hide-modal', 0.25, { y: -100 });
        sceneHideModal.setTween(tweenHide);
        controllerDay.addScene(sceneHideModal);

        return () => {
            scene && scene.destroy(true);
            sceneHideModal && sceneHideModal.destroy(true);
        };
    }, []);

    return (
        <div className={`${styles.firstKv} firstKv`}>
            <div className="opacity-box">
                <div className={`bg-box ${showAni ? 'animate-bg' : ''}`}>
                    <EFPic className={`bg-img ${showAni ? 'animate-img' : ''}`} name={[`${kvName}.webp`, `${kvName}.jpg`]} />
                </div>
            </div>
            <div className="show-box">
                <div className="translate-box kv-text__box">
                    <div className={`kv-box ${showAni ? 'kv-animate' : ''}`}>
                        <div className="kv-title">{t('firstKv.title')}</div>
                        <div className="kv-desc">{t('firstKv.desc')}</div>
                        <div className="kv-tip">{t('firstKv.tip')}</div>
                    </div>
                </div>
            </div>
            <div className="hide-modal"></div>
        </div>
    );
}
